'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

// import styles


// Load ng modules


var _invariant = require('invariant');

var _invariant2 = _interopRequireDefault(_invariant);

var _timezonesJson = require('timezones-json');

var _timezonesJson2 = _interopRequireDefault(_timezonesJson);

var _dateUtils = require('../../../../common/utils/date-utils');

var _currencies = require('../../../../common/utils/currencies');

var _mapStateToController = require('./mapStateToController');

var _mapStateToController2 = _interopRequireDefault(_mapStateToController);

var _feiseanna = require('ifeis-isomorphic/lib/redux/actions/feiseanna');

var _getFeatureFlags = require('ifeis-isomorphic/lib/redux/actions/feature-flags/getFeatureFlags');

require('./styles.scss');

var _ngFileUpload = require('ng-file-upload');

var _ngFileUpload2 = _interopRequireDefault(_ngFileUpload);

require('../../../../feiseanna');

require('../../../../immutables');

require('../../../../telephone');

require('../../../../payment-history');

var _ifeisIsomorphic = require('ifeis-isomorphic');

var _events = require('ifeis-isomorphic/lib/redux/actions/events');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SEARCH_ERROR_MSG = 'You must be registered to search for competitors';

var OneFeiseannaController = function () {
  function OneFeiseannaController($rootScope, $scope, $mdSidenav, $mdDialog, $filter, $state, $window, $q, fSession, config, fFeisService, editableOptions, msgService, fPaymentHistoryDialog, fAccountService, fEventService, fRegistrationService, feis, metadata, isGod, account, fPrompt, $ngRedux) {
    var _this = this;

    _classCallCheck(this, OneFeiseannaController);

    this.$state = $state;
    this.fSession = fSession;
    this.config = config;
    this.account = account;
    this._events = fEventService.for(feis.id);
    this._prepareFeisModel($rootScope.feis || feis);
    this._svc = {
      $mdSidenav: $mdSidenav, fSession: fSession, fFeisService: fFeisService, $filter: $filter, $mdDialog: $mdDialog, msgService: msgService, fPaymentHistoryDialog: fPaymentHistoryDialog, $window: $window, $q: $q, fPrompt: fPrompt, $ngRedux: $ngRedux
    };
    this.now = new Date().getTime();
    this.newContacts = [];
    this.newAccommodations = [];
    this.contactsInit = [];
    this.accommodationsInit = [];

    $ngRedux.dispatch((0, _getFeatureFlags.getFeatureFlags)()).then(function (response) {
      if (response.payload && response.payload.flags.isCrossNavigationEnabled) {
        _this.goToExternalUrl('feiseanna-list', feis.id, feis.slug);
      } else {
        _this._svc.$ngRedux.dispatch((0, _feiseanna.getGroupFeesForFeis)(feis.id));
        _this._svc.$ngRedux.connect((0, _mapStateToController2.default)(feis.id))(_this);

        _this._prepareFeisModel($rootScope.feis || feis);

        _this.searchByParticipant = false;
        _this.selectedEvent = null;
        _this.selectedParticipant = null;
        _this.participantEvents = null;
        _this._registrations = function () {
          return fRegistrationService.for(_this.feis.id);
        };

        /**
         * Add timezone array to scope
         */
        _this.tz = _timezonesJson2.default;

        _this.reg_num_methods = fFeisService.competitorNumberAssignmentMethods();

        /**
         * Determine if the user is a god
         */
        _this.isGod = isGod;
        _this.currencies = (0, _currencies.getCurrencies)();

        /**
         * Load contacts
         */
        fFeisService.contacts(_this.feis.id).then(function (contacts) {
          _this.contactsInit = contacts;
          _this.contacts = angular.copy(_this.contactsInit);
        });

        /**
         * Load grants
         */
        // fFeisService.myGrants( $stateParams.id ).then( (grants) => this.grants = grants );
        _this.grants = metadata.grants;
        _this.isChair = _this.grants.indexOf('chair') !== -1;
        _this.isRegistered = metadata.registered === 1;
        editableOptions.isDisabled = !_this.isChair && !_this.isGod;
        _this.canSearchParticipants = account ? !_this.isChair && !_this.isGod && _this.grants.indexOf('registration') < 0 : false;

        fFeisService.paidParticipants(_this.feis.id, { count: true }).then(function (res) {
          return _this.paidParticipants = res.count;
        });

        /**
         * Load accommodations
         */
        fFeisService.accommodations(_this.feis.id).then(function (accommodations) {
          _this.accommodationsInit = accommodations;
          _this.accommodations = angular.copy(_this.accommodationsInit);
        });

        /**
         * Check if account has Payments and Payments Due
         */

        if (account) {
          fAccountService.one(_this.account.id).then(function (acct) {
            acct.payments().then(function (res) {
              return _this.paymentsExist = res.some(function (payment) {
                return payment.feis.id === _this.feis.id;
              });
            }, function (err) {
              return _this._svc.msgService.displayErrorMsg(err);
            });

            acct.paymentsDue().then(function (res) {
              return _this.paymentsDueExist = res.some(function (due) {
                return due.feis.id === _this.feis.id;
              });
            }, function (err) {
              return _this._svc.msgService.displayErrorMsg(err);
            });
          });
        }

        /**
         * Load Attachments
         */
        fFeisService.getAttachments(_this.feis.id).then(function (attachments) {
          _this.attachments = attachments;
          _this.attachments.forEach(function (attachment) {
            attachment.is_editing = false;
          });
        });

        $scope.$watch(function () {
          return _this.fileToUpload;
        }, function (file) {
          if (!file || file === '') return;

          _this._svc.fPrompt({
            title: 'Enter File Name',
            label: 'File Name',
            value: file.name,
            action: 'Upload',
            type: 'text'
          }, null).then(function (name) {
            return _this._svc.fFeisService.createAttachment(_this.feis.id, file, name).then(function (newAttachment) {
              newAttachment.is_editing = false;
              _this.attachments.push(newAttachment);
            }).catch(function () {
              return _this._svc.msgService.displayErrorMsg('Could not upload file.');
            });
          }).catch(function (err) {
            return _this._svc.msgService.displayErrorMsg(err);
          });
        });
      }
    });
  }

  /**
   * Filter items
   *
   * @param filter {String}
   * @returns {Array}
   */

  _createClass(OneFeiseannaController, [{
    key: 'filterItems',
    value: function filterItems(filter) {
      var _this2 = this;

      if (!filter) {
        return [];
      }

      var items = {
        participants: this._svc.fFeisService.competitors(this.feis.id, {
          offset: 0,
          limit: 1000, // TODO change hard-coded number to unlimited (-1) request when API implements this
          filter: filter }),
        events: this._events.all({ filter: filter })
      };

      return this._svc.$q.all(items).then(function (response) {
        return response.events.reduce(function (participants, event) {
          participants.push({ participant: false, id: event.id, name: (0, _ifeisIsomorphic.getDescription)(event), participants: event.participants });
          return participants;
        }, response.participants.map(function (part) {
          return { participant: true, id: part.id, name: part.fname + ' ' + part.lname, competitor: part.competitor, school: part.school.name };
        }));
      }).catch(function () {
        _this2._svc.msgService.displayErrorMsg(SEARCH_ERROR_MSG);
        return [];
      });
    }
  }, {
    key: 'getDetail',
    value: function getDetail(item) {
      item && item.participant ? this.getParticipantEvents(item) : this.getParticipants(item);
    }
  }, {
    key: 'getParticipants',
    value: function getParticipants(event) {
      var _this3 = this;

      this.searchByParticipant = false;
      if (!!event) {
        if (event.participants && event.participants > 0) {
          this._events.participants(event.id).then(function (participants) {
            _this3.eventParticipants = participants.sort(function (a, b) {
              return a.competitor - b.competitor;
            });
            _this3.eventParticipants.forEach(function (p) {
              _this3._registrations().for(p.id).all().then(function (regs) {
                return p.$$events = regs;
              });
            });
          });
        } else {
          this.eventParticipants = null;
        }
      }
    }
  }, {
    key: 'getParticipantEvents',
    value: function getParticipantEvents(participant) {
      var _this4 = this;

      this.searchByParticipant = true;
      if (!!participant) {
        return this._registrations().for(participant.id).all().then(function (regs) {
          return _this4.participantEvents = regs;
        }) // , err => this._.msgService.displayErrorMsg(err)
        ;
      }
    }
  }, {
    key: 'canPublish',
    value: function canPublish() {
      return this.isChair && !this.feis.is_finalized;
    }
  }, {
    key: 'toggleAttachmentEditing',
    value: function toggleAttachmentEditing(attachment) {
      attachment.is_editing = !attachment.is_editing;
    }

    /**
     * updateAttachment
     */

  }, {
    key: 'updateAttachment',
    value: function updateAttachment(attachment) {
      var _this5 = this;

      return this._svc.fFeisService.updateAttachment(this.feis.id, attachment.id, attachment).then(function () {
        attachment.is_editing = false;
        _this5._svc.msgService.displaySuccessMsg('Attachment was successfully updated!');
      }).catch(function (error) {
        attachment.is_editing = false;
        _this5._svc.msgService.displayErrorMsg(error);
      });
    }

    /**
     * deleteAttachment
     */

  }, {
    key: 'deleteAttachment',
    value: function deleteAttachment(attachment) {
      var _this6 = this;

      var index = this.attachments.indexOf(attachment);
      return this._svc.fFeisService.deleteAttachment(this.feis.id, attachment.id).then(function (newAttachment) {
        if (index > -1) {
          _this6.attachments.splice(index, 1);
        }
        _this6._svc.msgService.displaySuccessMsg('Attachment was successfully deleted!');
      }).catch(function (error) {
        _this6.attachments[index].is_editing = false;
        _this6._svc.msgService.displayErrorMsg(error);
      });
    }
  }, {
    key: 'openPaymentsDialog',
    value: function openPaymentsDialog(ev) {
      var _this7 = this;

      this._svc.fPaymentHistoryDialog(ev, this.account, this.feis).then(function () {}, function (err) {
        return _this7._svc.msgService.displayErrorMsg(err);
      });
    }
  }, {
    key: 'convertDates',
    value: function convertDates() {
      this.feis._dt_start = this.feis.dt_start ? (0, _dateUtils.convertMsToDate)(this.feis.dt_start, this.feis.tz) : null;
      this.feis._dt_end = this.feis.dt_end ? (0, _dateUtils.convertMsToDate)(this.feis.dt_end, this.feis.tz) : null;
      this.feis._dt_reg_start = this.feis.dt_reg_start ? (0, _dateUtils.convertMsToDate)(this.feis.dt_reg_start, this.feis.tz) : null;
      this.feis._dt_reg_end = this.feis.dt_reg_end ? (0, _dateUtils.convertMsToDate)(this.feis.dt_reg_end, this.feis.tz) : null;
      this.feis._dt_reg_late = this.feis.dt_reg_late ? (0, _dateUtils.convertMsToDate)(this.feis.dt_reg_late, this.feis.tz) : null;

      // Make a local copy of initial Feis object
      this.feisInit = angular.copy(this.feis);
    }
  }, {
    key: '_prepareFeisModel',
    value: function _prepareFeisModel(newFeis) {
      this.feis = newFeis;
      this.convertDates();
    }
  }, {
    key: 'updateOrDeleteFeisEventCaps',
    value: function updateOrDeleteFeisEventCaps(propName, propNameToDelete) {
      var _this8 = this;

      // We want to clwan up the related property e.g. paid caps if the event cap is removed. This is for clean up.
      return this.updateFeis().then(_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (_this8.feis[propName]) {
                  _context.next = 3;
                  break;
                }

                _context.next = 3;
                return _this8._svc.$ngRedux.dispatch((0, _feiseanna.deleteFeiseannaProperties)(_this8.feis.id, propNameToDelete));

              case 3:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this8);
      })));
    }
  }, {
    key: 'updateFeis',
    value: function updateFeis() {
      var _this9 = this;

      if (this.feis.grades_events_cap && this.feis.grades_events_cap !== this.feisInit.grades_events_cap) {
        this.feis.paid_grades_dancers_count = undefined;
      }
      if (this.feis.prelims_events_cap && this.feis.prelims_events_cap !== this.feisInit.prelims_events_cap) {
        this.feis.paid_prelim_dancers_count = undefined;
      }
      if (this.feis.open_events_cap && this.feis.open_events_cap !== this.feisInit.open_events_cap) {
        this.feis.paid_champ_dancers_count = undefined;
      }
      var feisToSave = angular.copy(this.feis);
      if (!angular.equals(feisToSave, this.feisInit)) {
        // Convert dates to milliseconds.
        // If a date was removed, send null.
        feisToSave.dt_start = this.feis._dt_start ? (0, _dateUtils.convertDateToMs)(this.feis._dt_start, this.feis.tz) : null;
        feisToSave.dt_end = this.feis._dt_end ? (0, _dateUtils.convertDateToMs)(this.feis._dt_end, this.feis.tz, true) : null;
        feisToSave.dt_reg_start = this.feis._dt_reg_start ? (0, _dateUtils.convertDateToMs)(this.feis._dt_reg_start, this.feis.tz) : null;
        feisToSave.dt_reg_end = this.feis._dt_reg_end ? (0, _dateUtils.convertDateToMs)(this.feis._dt_reg_end, this.feis.tz, true) : null;
        feisToSave.dt_reg_late = this.feis._dt_reg_late ? (0, _dateUtils.convertDateToMs)(this.feis._dt_reg_late, this.feis.tz, true) : null;

        // Remove temp _dates properties
        Object.keys(feisToSave).forEach(function (key) {
          if (key.startsWith('_')) delete feisToSave[key];
        });

        return this._svc.fFeisService.update(feisToSave.id, feisToSave).then(function (newFeis) {
          _this9._prepareFeisModel(newFeis);
          _this9._svc.msgService.displaySuccessMsg('Feis was successfully updated!');
          return Promise.resolve();
        }, function (error) {
          return _this9._svc.msgService.displayErrorMsg(error);
        });
      }
    }

    /**
     * Group Fees
     */

  }, {
    key: 'addGroupFee',
    value: function addGroupFee() {
      this.groupFees.push({});
    }
  }, {
    key: 'deleteGroupFee',
    value: function deleteGroupFee(index) {
      var _this10 = this;

      var groupFee = this.groupFees[index];
      if (!groupFee || !this._groupFeeHasData(groupFee)) {
        this.groupFees.splice(index, 1);
        return;
      }
      var confirm = this._svc.$mdDialog.confirm().title('Delete Group Fee?').textContent('This process will Delete group fee. Are you sure?').cancel('Cancel').ok('Delete');
      return this._svc.$mdDialog.show(confirm).then(function () {
        _this10.groupFees.splice(index, 1);
        if (groupFee.id) {
          _this10._svc.$ngRedux.dispatch((0, _feiseanna.deleteGroupFeesForFeis)(_this10.feis.id, groupFee.id));
          _this10._svc.$ngRedux.dispatch((0, _events.deleteEligibleEventsForPerson)(_this10.account.id));
        }
      });
    }
  }, {
    key: 'updateGroupFee',
    value: function updateGroupFee(index) {
      var groupFee = this.groupFees[index],
          groupFeeInit = this.groupFeesInit.find(function (g) {
        return g.id === groupFee.id;
      });
      if (groupFee.id) {
        if (!angular.equals(groupFee, groupFeeInit)) {
          this._svc.$ngRedux.dispatch((0, _feiseanna.updateGroupFeesForFeis)(this.feis.id, groupFee));
          this._svc.$ngRedux.dispatch((0, _events.deleteEligibleEventsForPerson)(this.account.id));
        }
      } else if (!this.newGroupFees[this.newGroupFees.indexOf(groupFee)] && this._groupFeeHasData(groupFee)) {
        groupFee.trigger = 'Group Fee';
        groupFee.level = 'A';
        groupFee.type = 'R';
        groupFee.plural = true;

        this.newGroupFees.push(groupFee);
        return this._svc.$ngRedux.dispatch((0, _feiseanna.createGroupFeesForFeis)(this.feis.id, groupFee));
      }
    }

    // Check if group fee has any data entered

  }, {
    key: '_groupFeeHasData',
    value: function _groupFeeHasData(groupFee) {
      return groupFee.name && groupFee.amount;
    }

    /**
     * Contacts
     */

  }, {
    key: 'addContact',
    value: function addContact() {
      this.contacts.push({});
    }
  }, {
    key: 'deleteContact',
    value: function deleteContact(index) {
      var _this11 = this;

      if (this.contacts[index].id) {
        this._svc.fFeisService.deleteContact(this.feis.id, this.contacts[index].id).then(function (res) {
          return _this11._svc.msgService.displaySuccessMsg('Contact was successfully deleted.');
        }, function (err) {
          return _this11._svc.msgService.displayErrorMsg(err);
        });
      }
      this.contacts.splice(index, 1);
    }
  }, {
    key: 'updateContact',
    value: function updateContact(index) {
      var _this12 = this;

      var contact = this.contacts[index],
          contactInit = this.contactsInit.find(function (c) {
        return c.id === contact.id;
      });
      if (contact.id) {
        // If contact has no data,
        // remove it from db but keep in model for further updates
        if (!this._contactHasData(contact)) return this._svc.fFeisService.deleteContact(this.feis.id, contact.id);
        // Otherwise, update it, if it has been modified
        if (!angular.equals(contact, contactInit)) {
          return this._svc.fFeisService.updateContact(this.feis.id, contact.id, contact).then(function (newCont) {
            _this12._svc.msgService.displaySuccessMsg('Contact was successfully updated!');
            // Update local model
            _this12.contactsInit.forEach(function (oldCont, i) {
              if (oldCont.id === newCont.id) _this12.contactsInit[i] = newCont;
            });
          }, function (err) {
            return _this12._svc.msgService.displayErrorMsg(err);
          });
        }
      } else if (!this.newContacts[this.newContacts.indexOf(contact)] && this._addContactHasMandatoryData(contact)) {
        this.newContacts.push(contact);
        return this._svc.fFeisService.createContact(this.feis.id, contact).then(function (data) {
          _this12._svc.msgService.displaySuccessMsg('Contact was successfully created!');
          contact.id = data.id;
        }, function (err) {
          return _this12._svc.msgService.displayErrorMsg(err);
        });
      }
    }

    // Check if contact has any data entered

  }, {
    key: '_contactHasData',
    value: function _contactHasData(contact) {
      return contact.fname || contact.lname || contact.phone || contact.email;
    }
  }, {
    key: '_addContactHasMandatoryData',
    value: function _addContactHasMandatoryData(contact) {
      return contact.fname && contact.lname && contact.email;
    }

    /**
     * Accommodations
     */

  }, {
    key: 'addAccommodation',
    value: function addAccommodation() {
      this.accommodations.push({});
    }
  }, {
    key: 'deleteAccommodation',
    value: function deleteAccommodation(index) {
      var _this13 = this;

      if (this.accommodations[index].id) {
        this._svc.fFeisService.deleteAccommodation(this.feis.id, this.accommodations[index].id).then(function (res) {
          return _this13._svc.msgService.displaySuccessMsg('Accommodation was successfully deleted.');
        }, function (err) {
          return _this13._svc.msgService.displayErrorMsg(err);
        });
      }
      this.accommodations.splice(index, 1);
    }
  }, {
    key: 'updateAccommodation',
    value: function updateAccommodation(index) {
      var _this14 = this;

      var accommodation = this.accommodations[index],
          accInit = this.accommodationsInit.find(function (acc) {
        return acc.id === accommodation.id;
      });
      if (accommodation.id) {
        // If Accommodation has no data,
        // remove it from db but keep in model for further updates
        if (!this._accommodationHasData(accommodation)) return this._svc.fFeisService.deleteAccommodation(this.feis.id, accommodation.id);
        // Otherwise, update it, if it has been modified
        if (!angular.equals(accommodation, accInit)) {
          return this._svc.fFeisService.updateAccommodation(this.feis.id, accommodation.id, accommodation).then(function (newAcc) {
            _this14._svc.msgService.displaySuccessMsg('Accommodation was successfully updated!');
            // Update local model
            _this14.accommodationsInit.forEach(function (oldAcc, i) {
              if (oldAcc.id === newAcc.id) _this14.accommodationsInit[i] = newAcc;
            });
          }, function (err) {
            return _this14._svc.msgService.displayErrorMsg(err);
          });
        }
      } else if (!this.newAccommodations[this.newAccommodations.indexOf(accommodation)] && this._accommodationHasData(accommodation)) {
        this.newAccommodations.push(accommodation);
        return this._svc.fFeisService.createAccommodation(this.feis.id, accommodation).then(function (data) {
          _this14._svc.msgService.displaySuccessMsg('Accommodation was successfully created!');
          accommodation.id = data.id;
        }, function (err) {
          return _this14._svc.msgService.displayErrorMsg(err);
        });
      }
    }

    // Check if accommodation has any data entered

  }, {
    key: '_accommodationHasData',
    value: function _accommodationHasData(acc) {
      return acc.name || acc.address || acc.url || acc.rate;
    }

    /**
     * Participants
     */

  }, {
    key: 'constructMailto',
    value: function constructMailto() {
      var _this15 = this;

      this._svc.fFeisService.personnel(this.feis.id).then(function (personnel) {

        // Get Feis Chair
        _this15.feisChair = personnel.find(function (p) {
          return p.role === 'chair';
        });

        // Prepare mailto
        _this15._svc.fFeisService.unpaidAccounts(_this15.feis.id).then(function (p) {
          _this15.unpaidAccountsEmails = p.map(function (p) {
            return p.email;
          }).join(';');
        }).then(function (p) {
          var mailtoStr = 'mailto:' + _this15.feisChair.person.email + '?subject=Make%20a%20Payment&bcc=' + _this15.unpaidAccountsEmails;
          _this15._createTempAnchor(mailtoStr);
        });
      });
    }
  }, {
    key: 'getEventName',
    value: function getEventName(event) {
      return (0, _ifeisIsomorphic.getDescription)(event);
    }
  }, {
    key: 'goToExternalUrl',
    value: function goToExternalUrl(path, id, slug) {
      if (!path) return;
      var url = IFEIS_APPV2_URI + '/' + path;
      if (id && slug) {
        url = url + '/' + id + '/' + slug;
      }
      window.location.replace(url);
    }
  }]);

  return OneFeiseannaController;
}();

exports.default = angular.module('ifeis.routes.feiseanna.one.landing-page', ['ui.router', 'xeditable', _ngFileUpload2.default, 'ifeis.feiseanna', 'ifeis.telephone', 'ifeis.immutables', 'ifeis.payment-history']).config(function ($stateProvider) {
  $stateProvider.state('feiseanna.one.landing-page', {
    url: '',
    template: require('./tpl.html'),
    controller: 'OneFeiseannaController',
    controllerAs: 'one',
    ncyBreadcrumb: {
      label: '{{ breadcrumbsFeisName }}'
    }
  });
}).filter('filterByDay', function () {
  return function (stages, day) {
    if (!stages) return stages;

    return stages.filter(function (s) {
      var stg = s.toObject();
      return stg.dt === day.date;
    });
  };
}).filter('filterOutExistingDays', function () {
  return function (stages, feisDays) {
    if (!stages) return stages;

    return stages.filter(function (s) {
      var stg = s.toObject();
      return feisDays.find(function (d) {
        return d.date === stg.dt;
      }) === undefined;
    });
  };
}).controller('OneFeiseannaController', OneFeiseannaController);


//////////////////
// WEBPACK FOOTER
// ./routes/feiseanna/one/landing-page/index.js
// module id = 586
// module chunks = 0